import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
